// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"cfcf62b7","453":"e0b4df19","847":"e0de0d1e"}[chunkId] + ".chunk.js";
};